import HttpStatus from 'ha/constants/HttpStatus';

import { ApiError } from './errors';

export default function handleApiV2Response(response: Response) {
  const { ok, status, statusText } = response;

  return Promise.resolve()
    .then(() => {
      if (status === HttpStatus.NO_CONTENT) {
        return undefined;
      }

      if (status === HttpStatus.ENTITY_TOO_LARGE) {
        throw new ApiError(status, statusText, {});
      }

      return response.json();
    })
    .then(data => {
      if (!ok) {
        throw new ApiError(status, statusText, data);
      }

      return { status, data };
    });
}
